// Author Lin
// Date 2024-07-31 10:37:07

class SithMesInventoryReceiptReturnRecord {
    constructor({
                    id = null,
                    poitemId = '',
                    parentId = '',
                    childReceiptQuantity = '',
                    operateType = '',
                    receiptQuantity = '',
                    returnQuantity = '',
                    inspectStatus = '',
                    credential = '',
                    batchNumber = '',
                    documentYear = '',
                    operateTime = '',
                    remark = '',
                    operationId = '',
                    successOperation = ''
                }
                        = {}) {
        this.id = id;
        this.poitemId = poitemId;
        this.parentId = parentId;
        this.childReceiptQuantity = childReceiptQuantity;
        this.operateType = operateType;
        this.receiptQuantity = receiptQuantity;
        this.returnQuantity = returnQuantity;
        this.inspectStatus = inspectStatus;
        this.credential = credential;
        this.batchNumber = batchNumber;
        this.documentYear = documentYear;
        this.operateTime = operateTime;
        this.remark = remark;
        this.operationId = operationId;
        this.successOperation = successOperation;
    }
}

function newEntity() {
    return new SithMesInventoryReceiptReturnRecord();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'poitemId',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.poitemId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'poNumber',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.poNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'itemCode',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.itemCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialCode',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.materialCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialName',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.materialName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'packingMaterial',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.packingMaterial',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'vendorNumber',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.vendorNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'proName',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.proName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'proNo',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.proNo',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'plant',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.plant',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'operateType',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.operateType',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '0', text: '入场接货'},
                    {value: '1', text: '101收货'},
                    {value: '2', text: '102退货'},
                    {value: '3', text: '103收货'},
                    {value: '4', text: '104退货'},
                    {value: '5', text: '105收货'},
                    {value: '6', text: '106退货'}
                ]
            }
        },
        {
            key: 'receiptQuantity',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.receiptQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'returnQuantity',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.returnQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'inspectStatus',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.inspectStatus',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '检验合格'},
                    {value: '2', text: '已提交检验'},
                    {value: '3', text: '未提交检验'},
                    {value: '4', text: '检验不合格'}
                ]
            }
        },
        {
            key: 'credential',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.credential',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'operateTime',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.operateTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'operator',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.operator',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'batchNumber',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.batchNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'documentYear',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.documentYear',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'submitter',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.submitter',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'submitTime',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.submitTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'inspector',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.inspector',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'inspectTime',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.inspectTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remarkOf103',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.remarkOf103',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'operationId',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.operationId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'orderCode',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.orderCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'operationSeq',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.operationSeq',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prNumber',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.prNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prItemNumber',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.prItemNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'operationDesc',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.operationDesc',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'headerMat',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.headerMat',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'headerMatDesc',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.headerMatDesc',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'successOperation',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.successOperation',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'assignedConsigneeId',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.assignedConsigneeId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'assignedConsignee',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.assignedConsignee',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'operatePosition',
            label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.grid.operatePosition',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    poItemIdListFilter: [],
    poitemIdFilter: '',
    purchaseNumberFilter: '',
    itemCodeFilter: '',
    materialCodeFilter: '',
    packingMaterialFilter: '',
    parentIdFilter: '',
    childReceiptQuantityFilter: '',
    operateTypeFilter: '',
    operateTypesFilter: [],
    receiptQuantityFilter: '',
    returnQuantityFilter: '',
    inspectStatusFilter: '',
    credentialFilter: '',
    batchNumberFilter: '',
    documentYearFilter: '',
    operateTimeRteFilter: '',
    operateTimeLteFilter: '',
    operationIdFilter: '',
    orderCodeFilter: '',
    operationSeqFilter: '',
    successOperationFilter: '',
    englishNameFilter: '',
    assignedConsigneeIdFilter: '',
    assignedConsigneeFilter: '',
    operatePositionIdFilter: '',
    operatePositionFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'purchaseNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.filter.purchaseNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.filter.itemCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.filter.materialCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packingMaterialFilter',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.filter.packingMaterial',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operateTypeFilter',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.filter.operateType',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '入场接货'},
                {value: '1', text: '101收货'},
                {value: '2', text: '102退货'},
                {value: '3', text: '103收货'},
                {value: '4', text: '104退货'},
                {value: '5', text: '105收货'},
                {value: '6', text: '106退货'}
            ]
        }
    },
    {
        key: 'receiptQuantityFilter',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.filter.receiptQuantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'returnQuantityFilter',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.filter.returnQuantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectStatusFilter',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.filter.inspectStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '检验合格'},
                {value: '2', text: '已提交检验'},
                {value: '3', text: '未提交检验'},
                {value: '4', text: '检验不合格'}
            ]
        }
    },
    {
        key: 'credentialFilter',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.filter.credential',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'batchNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.filter.batchNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'documentYearFilter',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.filter.documentYear',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operateTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.filter.operateTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operateTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.filter.operateTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.filter.orderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operationSeqFilter',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.filter.operationSeq',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'successOperationFilter',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.filter.successOperation',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'assignedConsigneeFilter',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.filter.assignedConsignee',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"assignedConsigneeId":"id"}'
        }
    },
    {
        key: 'operatePositionFilter',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.filter.operatePosition',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryAreaLoc'
            , correspondingField: 'areaName'
            , fieldsBindingByEntityModalSelected: '{"operatePositionId":"id"}'
        }
    }
];
const entityFormConfigs = [
    {
        key: 'poitemId',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.entity.poitemId',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'parentId',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'childReceiptQuantity',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.entity.childReceiptQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operateType',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.entity.operateType',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '入场接货'},
                {value: '1', text: '101收货'},
                {value: '2', text: '102退货'},
                {value: '3', text: '103收货'},
                {value: '4', text: '104退货'},
                {value: '5', text: '105收货'},
                {value: '6', text: '106退货'}
            ]
        }
    },
    {
        key: 'receiptQuantity',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.entity.receiptQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'returnQuantity',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.entity.returnQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectStatus',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.entity.inspectStatus',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '检验合格'},
                {value: '2', text: '已提交检验'},
                {value: '3', text: '未提交检验'},
                {value: '4', text: '检验不合格'}
            ]
        }
    },
    {
        key: 'credential',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.entity.credential',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'batchNumber',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.entity.batchNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'documentYear',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.entity.documentYear',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operateTime',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.entity.operateTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operationId',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.entity.operationId',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'successOperation',
        label: 'label.sith.inventory.sithMesInventoryReceiptReturnRecord.entity.successOperation',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    SithMesInventoryReceiptReturnRecord, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
